import { formatBtuOutput } from 'utils/ducted-zone-performance';

type DuctedPairSectionHeadingProps = Readonly<{
  pairName: string;
  coolingBtu: number;
  systemName: string | null;
}>;

export default function DuctedPairSectionHeading({
  pairName,
  coolingBtu,
  systemName
}: DuctedPairSectionHeadingProps) {
  return (
    <div className='flex flex-wrap items-baseline gap-x-2 text-xs font-semibold uppercase tracking-wider text-gray-500'>
      <span>{pairName}</span>
      <span className='font-normal normal-case tracking-normal text-gray-400'>
        {formatBtuOutput(coolingBtu)} cooling
        {systemName !== null && ` · replaces ${systemName}`}
      </span>
    </div>
  );
}
